import React, { useState } from "react";
import "../../styles/Header.css";
import { useDispatch } from "react-redux";
import { logout } from "../../services/LoginAPI.tsx";
import { useMsal } from "@azure/msal-react";
import { Alert } from "reactstrap";
import AlertPopup from "../UI/AlertPopup.tsx";

const Header: React.FC = () => {
  const [modal, setModal] = useState(false);

  const dispatch: any = useDispatch();
  const { instance } = useMsal();
  const handleLogout = () => {
    dispatch(logout(instance));
  };

  return (
    <>
      <div className="header-container">
        <div className="img-container">
          <img
            alt="header-logo"
            className="header-logo"
            src={require("../../assets/images/kshema_logo.svg").default}
          ></img>
          <span className="header"> Finder Dashboard</span>
        </div>

        <div className="logoutDiv">
          <button className="logout-button" onClick={()=>{setModal(!modal)}}>
            Logout
          </button>
        </div>
      </div>
      
      <AlertPopup 
        isOpen={modal}
        toggle={()=>{setModal(!modal)}}
        onAction={handleLogout}
      />
    </>
  );
};

export default Header;
